<!-- Modo panel flotante: overlay y panel con posición fija (cuando no está dentro de ion-menu) -->
<ng-container *ngIf="!dentroDeMenu">
  <div class="formulario-overlay" *ngIf="visible">
    <div class="formulario-overlay-backdrop" (click)="cerrar()" (touchend)="onOverlayTouchend($event)" role="button"
      tabindex="-1" aria-label="Cerrar panel"></div>
    <div class="formulario-overlay-cutout" aria-hidden="true"></div>
  </div>
  <div class="formulario-panel" [class.visible]="visible">
    <ng-container *ngTemplateOutlet="contenidoFormulario"></ng-container>
  </div>
</ng-container>

<!-- Modo dentro de ion-menu: solo el contenido (el menú aporta animación y backdrop) -->
<div class="formulario-contenido-menu" *ngIf="dentroDeMenu">
  <ng-container *ngTemplateOutlet="contenidoFormulario"></ng-container>
</div>

<ng-template #contenidoFormulario>
  <div class="formulario-header">
    <div class="header-main-flex">
      <div class="header-titulos">
        <h2>{{ getTitulo() }}</h2>
        <p class="subtitulo subtitulo-registrar" *ngIf="accion === 'registrar'">
          Registre los resultados de la visita a <strong>{{ getNombreCompletoProductor(visita?.productor) }}</strong>
        </p>
        <p class="subtitulo" *ngIf="accion === 'nueva'">Complete el formulario para programar una nueva visita.</p>
      </div>

    </div>

    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content" #formularioContent>
    <!-- Spinner de carga -->
    <div class="loading-container" *ngIf="cargando">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando...</p>
    </div>

    <!-- Ver Detalles: mismo acordeón que historial-visitas en gestión; la visita consultada abierta por defecto -->
    <div class="vista-detalles vista-detalles-historial" *ngIf="!cargando && accion === 'ver-detalles'">
      <p class="subtitulo-historial-visita">Historial del productor: expanda cada intervención para ver el detalle
        completo de la visita.</p>

      <div class="estado-historial estado-historial-error" *ngIf="historialError">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <p>{{ historialError }}</p>
      </div>

      <div class="estado-historial" *ngIf="!historialError && visitasHistorialPanel.length === 0">
        <ion-icon name="document-outline"></ion-icon>
        <p>No hay intervenciones registradas para este productor.</p>
      </div>

      <div class="historial-accordion-fullbleed" *ngIf="visitasHistorialPanel.length > 0">
        <ion-accordion-group [value]="accordionHistorialAbierto" (ionChange)="onAccordionHistorialChange($event)"
          class="accordion-visitas">
          <ion-accordion *ngFor="let item of visitasHistorialPanel" [value]="item.id_visita"
            [attr.data-historial-id]="item.id_visita">
            <ion-item slot="header" class="accordion-header">
              <ion-label>
                <div class="header-linea-titulo">
                  <span class="header-tipo">{{ valorOSinInfo(item.tipo) }}</span>
                  <span class="badge-estado-resumen" [ngClass]="getClaseEstadoHistorialVisita(item.estado)">
                    {{ valorOSinInfo(item.estado) }}
                  </span>

                  <!-- Botón de descarga PDF (Solo si permitirPdf es true y la visita está finalizada) -->
                  <div *ngIf="permitirPdf" 
                       class="enlace-descarga-pdf-blue" 
                       (click)="descargarPDF($event, item)">
                    <ion-icon name="document-text-outline"></ion-icon>
                    <span>Descargar PDF</span>
                  </div>
                </div>
                <div class="header-linea-meta">
                  <span class="header-fecha">
                    <ion-icon name="calendar-outline" class="icono-medio"></ion-icon>
                    {{ formatearFechaHistorialVisita(item.fecha) }}
                    <span class="header-fecha-hora-sep" aria-hidden="true">·</span>
                    {{ formatearHoraHistorialVisita(item.fecha) }}
                  </span>
                  <span class="header-usuario">
                    <ion-icon name="person-outline" class="icono-medio"></ion-icon>
                    {{ valorOSinInfo(item.usuario) }}
                  </span>
                </div>
              </ion-label>
            </ion-item>
            <div slot="content" class="accordion-content">
              <ng-container *ngIf="historialCargandoDetalleIds.has(item.id_visita); else contenidoDetalleHistorial">
                <div class="content-loading">
                  <ion-spinner name="crescent"></ion-spinner>
                  <span>Cargando detalle...</span>
                </div>
              </ng-container>
              <ng-template #contenidoDetalleHistorial>
                <ng-container *ngIf="historialDetallesPorId[item.id_visita] as detalle">
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="person-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Usuario INDAP (productor)</span>
                      <span class="valor">{{ valorOSinInfo(getNombreCompletoProductor(detalle.productor)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="location-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Lugar</span>
                      <span class="valor">{{ valorOSinInfo(detalle.lugar) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="getDescripcionVisitaHistorial(detalle)">
                    <span class="campo-icono"><ion-icon name="document-text-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Descripción</span>
                      <div class="valor texto-observaciones">{{ valorOSinInfo(getDescripcionVisitaHistorial(detalle)) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="esVisitaPlanificadaHistorial(detalle)">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha inicio planificada</span>
                      <span class="valor">{{ valorOSinInfo(getFechaInicioPlanificadaHistorial(detalle)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="esVisitaPlanificadaHistorial(detalle) && getFechaTerminoPlanificadaHistorial(detalle)">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha término planificada</span>
                      <span class="valor">{{ valorOSinInfo(getFechaTerminoPlanificadaHistorial(detalle)) }}</span>
                    </div>
                  </div>
                  <ng-container *ngIf="!esVisitaPlanificadaHistorial(detalle)">
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha de realización</span>
                      <span class="valor">{{ valorOSinInfo(getFechaRealizacionHistorial(detalle)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="time-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Hora inicio</span>
                      <span class="valor">{{ valorOSinInfo(formatearHoraMostrar(detalle.hora_inicio || '')) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="time-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Hora término</span>
                      <span class="valor">{{ valorOSinInfo(formatearHoraMostrar(detalle.hora_termino || '')) }}</span>
                    </div>
                  </div>
                  </ng-container>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="people-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Consultor</span>
                      <span class="valor">{{ valorOSinInfo(detalle.usuario_registro) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="documents-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Tipo de Reporte</span>
                      <span class="valor">{{ valorOSinInfo(formatearTipoReporte(detalle.tipo_reporte)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="call-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Modalidad de contacto</span>
                      <span class="valor">{{ valorOSinInfo(textoModalidadContactoHistorial(detalle)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Temas</span>
                      <ul class="lista-temas-valor" *ngIf="listaObjetivosHistorial(detalle).length > 0; else sinObjetivos">
                        <li *ngFor="let tema of listaObjetivosHistorial(detalle)">{{ tema }}</li>
                      </ul>
                      <ng-template #sinObjetivos><span class="valor">S/I</span></ng-template>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="'objetivo_otro' in detalle">
                    <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Describa otro (Tema)</span>
                      <span class="valor">{{ detalle.objetivo_otro || '—' }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="pricetag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Folio</span>
                      <span class="valor">{{ valorOSinInfo(detalle.folio) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="bulb-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Recomendaciones</span>
                      <div class="valor texto-observaciones">{{ valorOSinInfo(detalle.recomendaciones) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="checkmark-done-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Compromisos adquiridos</span>
                      <ul class="lista-compromisos valor"
                        *ngIf="lineasCompromisosHistorial(detalle.compromisos).length > 0">
                        <li *ngFor="let linea of lineasCompromisosHistorial(detalle.compromisos)">{{ linea }}</li>
                      </ul>
                      <span class="valor"
                        *ngIf="lineasCompromisosHistorial(detalle.compromisos).length === 0">S/I</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="briefcase-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Bolsa de Visita</span>
                      <span class="valor badge-si-no">{{ valorOSinInfo(textoBolsaVisitaHistorial(detalle)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="alert-circle-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Es emergencia</span>
                    <span class="valor badge-emergencia"
                      [ngClass]="getClaseEmergenciaHistorial(detalle)">{{ valorOSinInfo(textoEsEmergenciaHistorial(detalle)) }}</span>
                  </div>
                </div>
                <div class="campo-caract" *ngIf="mostrarDescripcionEmergenciaHistorial(detalle)">
                  <span class="campo-icono"><ion-icon name="warning-outline"></ion-icon></span>
                  <div class="campo-texto">
                    <span class="etiqueta">Descripción de la emergencia</span>
                    <div class="valor texto-observaciones">{{ valorOSinInfo(detalle.descripcion_emergencia) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="documents-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Adjuntos</span>
                      <ng-container *ngIf="detalle.adjuntos?.length; else sinAdjuntosHistorial">
                        <div class="adjuntos-detalle-lista">
                          <div class="adjunto-detalle-bloque" *ngFor="let adj of detalle.adjuntos">
                            <button type="button" class="btn-adjunto btn-adjunto-accion" *ngIf="(adj.ruta_almacenamiento || '').trim()"
                              (click)="abrirODescargarAdjunto(adj)" [title]="valorOSinInfo(adj.nombre_archivo)">
                              <ion-icon name="eye-outline" class="btn-adjunto-icono" aria-hidden="true"></ion-icon>
                              <span class="btn-adjunto-categoria-nombre">
                                <span class="btn-adjunto-badge">{{ textoCategoriaAdjuntoHistorial(adj) || 'Documento'
                                  }}</span>
                                <span class="btn-adjunto-nombre">{{ valorOSinInfo(adj.nombre_archivo) }}</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #sinAdjuntosHistorial>
                        <span class="valor">S/I</span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="campo-caract campo-resumen-firmado" *ngIf="adjuntoResumenFirmado(detalle) as adjResumen">
                    <span class="campo-icono"><ion-icon name="document-attach-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Resumen firmado</span>
                      <div class="adjuntos-detalle-lista">
                        <div class="adjunto-detalle-bloque">
                          <button
                            type="button"
                            class="btn-adjunto btn-adjunto-accion"
                            [title]="'Ver o descargar: ' + adjResumen.nombre_archivo"
                            [attr.aria-label]="'Ver o descargar resumen firmado ' + adjResumen.nombre_archivo"
                            (click)="abrirResumenFirmado(detalle)">
                            <ion-icon name="eye-outline" class="btn-adjunto-icono" aria-hidden="true"></ion-icon>
                            <span class="btn-adjunto-categoria-nombre">
                              <span class="btn-adjunto-badge">RESUMEN FIRMADO</span>
                              <span class="btn-adjunto-nombre">{{ valorOSinInfo(adjResumen.nombre_archivo) }}</span>
                            </span>
                          </button>
                          <p class="adjunto-fecha-subida" *ngIf="textoFechaSubidaResumen(adjResumen) as fechaSub">
                            Subido {{ fechaSub }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>


                </ng-container>
                <ng-container *ngIf="!historialDetallesPorId[item.id_visita]">
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="person-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Usuario INDAP (productor)</span>
                      <span class="valor">{{ valorOSinInfo(getNombreCompletoProductor(item.productor)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="location-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Lugar</span>
                      <span class="valor">{{ valorOSinInfo(item.lugar) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="getDescripcionVisitaHistorial(item)">
                    <span class="campo-icono"><ion-icon name="document-text-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Descripción</span>
                      <div class="valor texto-observaciones">{{ valorOSinInfo(getDescripcionVisitaHistorial(item)) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="esVisitaPlanificadaHistorial(item)">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha inicio planificada</span>
                      <span class="valor">{{ valorOSinInfo(getFechaInicioPlanificadaHistorial(item)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="esVisitaPlanificadaHistorial(item) && getFechaTerminoPlanificadaHistorial(item)">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha término planificada</span>
                      <span class="valor">{{ valorOSinInfo(getFechaTerminoPlanificadaHistorial(item)) }}</span>
                    </div>
                  </div>
                  <ng-container *ngIf="!esVisitaPlanificadaHistorial(item)">
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="calendar-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Fecha de realización</span>
                      <span class="valor">{{ valorOSinInfo(getFechaRealizacionHistorial(item)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="time-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Hora inicio</span>
                      <span class="valor">{{ valorOSinInfo(formatearHoraMostrar(item.hora_inicio || '')) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="time-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Hora término</span>
                      <span class="valor">{{ valorOSinInfo(formatearHoraMostrar(item.hora_termino || '')) }}</span>
                    </div>
                  </div>
                  </ng-container>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="people-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Consultor</span>
                      <span class="valor">{{ valorOSinInfo(item.usuario_registro) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="documents-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Tipo de Reporte</span>
                      <span class="valor">{{ valorOSinInfo(formatearTipoReporte(item.tipo_reporte)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="call-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Modalidad de contacto</span>
                      <span class="valor">{{ valorOSinInfo(textoModalidadContactoHistorial(item)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Temas</span>
                      <ul class="lista-temas-valor" *ngIf="listaObjetivosHistorial(item).length > 0; else sinObjetivos">
                        <li *ngFor="let tema of listaObjetivosHistorial(item)">{{ tema }}</li>
                      </ul>
                      <ng-template #sinObjetivos><span class="valor">S/I</span></ng-template>
                    </div>
                  </div>
                  <div class="campo-caract" *ngIf="'objetivo_otro' in item">
                    <span class="campo-icono"><ion-icon name="flag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Describa otro (Tema)</span>
                      <span class="valor">{{ item.objetivo_otro || '—' }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="pricetag-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Folio</span>
                      <span class="valor">{{ valorOSinInfo(item.folio) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="bulb-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Recomendaciones</span>
                      <div class="valor texto-observaciones">{{ valorOSinInfo(item.recomendaciones) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="checkmark-done-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Compromisos adquiridos</span>
                      <ul class="lista-compromisos valor"
                        *ngIf="lineasCompromisosHistorial(item.compromisos).length > 0">
                        <li *ngFor="let linea of lineasCompromisosHistorial(item.compromisos)">{{ linea }}</li>
                      </ul>
                      <span class="valor" *ngIf="lineasCompromisosHistorial(item.compromisos).length === 0">S/I</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="briefcase-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Bolsa de Visita</span>
                      <span class="valor badge-si-no">{{ valorOSinInfo(textoBolsaVisitaHistorial(item)) }}</span>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="alert-circle-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Es emergencia</span>
                    <span class="valor badge-emergencia"
                      [ngClass]="getClaseEmergenciaHistorial(item)">{{ valorOSinInfo(textoEsEmergenciaHistorial(item)) }}</span>
                  </div>
                </div>
                <div class="campo-caract" *ngIf="mostrarDescripcionEmergenciaHistorial(item)">
                  <span class="campo-icono"><ion-icon name="warning-outline"></ion-icon></span>
                  <div class="campo-texto">
                    <span class="etiqueta">Descripción de la emergencia</span>
                    <div class="valor texto-observaciones">{{ valorOSinInfo(item.descripcion_emergencia) }}</div>
                    </div>
                  </div>
                  <div class="campo-caract">
                    <span class="campo-icono"><ion-icon name="documents-outline"></ion-icon></span>
                    <div class="campo-texto">
                      <span class="etiqueta">Adjuntos</span>
                      <span class="valor">S/I</span>
                    </div>
                  </div>

                  <!-- Botón Descargar PDF (Solo en ver-detalles) -->
                  <div class="bloque-descarga-pdf" *ngIf="permitirPdf">
                    <ion-button fill="outline" size="small" class="btn-descarga-pdf-detalle" (click)="descargarPDF($event, item)">
                      <ion-icon slot="start" name="document-text-outline"></ion-icon>
                      Descargar PDF
                    </ion-button>
                  </div>
                </ng-container>
              </ng-template>
            </div>
          </ion-accordion>
        </ion-accordion-group>
      </div>
    </div>

    <!-- Formulario de registro de visita (API /visita/{id}/registrar) -->
    <form [formGroup]="formularioRegistro" *ngIf="!cargando && accion !== 'ver-detalles' && esAccionRegistrar()"
      class="form-registro">
      <section class="registro-seccion">
        <h3 class="registro-seccion-titulo">FECHA Y HORA DE REALIZACIÓN</h3>
        <div class="registro-fecha-hora">
          <div class="registro-campo form-item">
            <ion-label position="stacked">FECHA DE VISITA <span class="required">*</span></ion-label>
            <ion-datetime-button datetime="datetime-fecha-registro"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime id="datetime-fecha-registro" [value]="fechaVisitaRegistroISO || undefined"
                  [min]="getFechaMinimaRegistroISO()" (ionChange)="onFechaRegistroChange($event)" locale="es-CL"
                  presentation="date" [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">HORA INICIO <span class="required">*</span></ion-label>
            <ion-datetime-button datetime="datetime-hora-inicio-registro"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime id="datetime-hora-inicio-registro" [value]="horaInicioRegistro || undefined"
                  (ionChange)="onHoraInicioRegistroChange($event)" locale="en-US" presentation="time"
                  [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">HORA TÉRMINO</ion-label>
            <ion-datetime-button datetime="datetime-hora-termino-registro"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime id="datetime-hora-termino-registro" [value]="getHoraTerminoRegistroValueISO()"
                  [min]="getHoraTerminoMinimaRegistroISO()" (ionChange)="onHoraTerminoRegistroChange($event)"
                  locale="en-US" presentation="time"
                  [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
        </div>
      </section>

      <section class="registro-seccion">
        <ion-radio-group formControlName="tipo_reporte" class="tipo-reporte-group" allowEmptySelection="true">
          <ion-label class="tipo-reporte-label">
            TIPO DE REPORTE <span class="required">*</span>
          </ion-label>
          <div class="tipo-reporte-options" role="group" aria-label="Tipo de reporte">
            <ion-radio class="tipo-reporte-radio" value="digital" labelPlacement="end" justify="start">
              Digital
            </ion-radio>
            <ion-radio class="tipo-reporte-radio" value="papel" labelPlacement="end" justify="start">
              Papel
            </ion-radio>
          </div>
        </ion-radio-group>
      </section>

      <section class="registro-seccion" *ngIf="getTipoReporteRegistro()">
        <h3 class="registro-seccion-titulo">DETALLES DEL REGISTRO</h3>
        <div class="registro-objetivo-folio">
          <div class="registro-campo form-item registro-campo-fila-completa">
            <ion-label position="stacked">TEMAS <span class="required">*</span></ion-label>
            <app-selector-objetivos-visita-registro
              formControlName="id_objetivo_visita"
              [objetivosVisita]="objetivosVisita">
            </app-selector-objetivos-visita-registro>
          </div>
          <div class="registro-campo form-item registro-campo-fila-completa" *ngIf="formularioRegistro.get('id_objetivo_visita')?.value?.includes(13)">
            <ion-label position="stacked">Describa otro <span class="required">*</span></ion-label>
            <ion-input formControlName="objetivo_otro" placeholder="Describa el tema"></ion-input>
          </div>
          <div class="registro-campo form-item registro-campo-fila-completa">
            <ion-label position="stacked">MODALIDAD DE CONTACTO <span class="required">*</span></ion-label>
            <ion-select formControlName="id_modalidad_contacto" placeholder="Seleccione modalidad" interface="popover"
              [compareWith]="compareIdModalidadContacto"
              [disabled]="!esModalidadContactoRegistroEditable()"
              [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
              <ion-select-option *ngFor="let mod of modalidadesContacto" [value]="mod.id_modalidad_contacto">
                {{ mod.descripcion }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="registro-campo form-item registro-campo-generar-folio">
            <div class="registro-generar-folio-wrapper">
              <ion-item class="form-item form-item-checkbox" lines="none">
                <ion-checkbox formControlName="generar_folio" labelPlacement="end"
                  (ionChange)="onGenerarFolioRegistroChange($event)">
                  Generar Folio
                </ion-checkbox>
              </ion-item>
              <ion-button [id]="idGenerarFolioInfo" fill="clear" size="small" class="boton-informacion"
                aria-label="Información sobre generar folio">
                <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
              </ion-button>
              <ion-popover [trigger]="idGenerarFolioInfo" [triggerAction]="'click'" reference="trigger" [side]="'top'"
                [alignment]="'center'">
                <ng-template>
                  <div class="popover-informacion">
                    <p>Al marcar esta opción, el sistema asignará automáticamente un número de folio al registrar la visita. No debe ingresar el folio del manifold manualmente.</p>
                  </div>
                </ng-template>
              </ion-popover>
            </div>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">FOLIO
              <span class="required" *ngIf="esFolioRegistroManualRequerido()">*</span>
            </ion-label>
            <ion-input formControlName="folio" placeholder="Nro. de folio del manifold" maxlength="15"
              [readonly]="!esFolioRegistroEditable()" (ionInput)="onFolioInput($event)"></ion-input>
          </div>
        </div>
        <div class="registro-campo bloque form-item">
          <ion-label position="stacked">RECOMENDACIONES
            <span class="required" *ngIf="getTipoReporteRegistro() === 'digital'">*</span>
          </ion-label>
          <ion-textarea formControlName="recomendaciones" placeholder="Recomendaciones realizadas." rows="2"
            class="registro-textarea" maxlength="500"></ion-textarea>
          <div class="contador-caracteres">
            {{ formularioRegistro.get('recomendaciones')?.value?.length || 0 }} de 500
          </div>
        </div>
        <div class="registro-campo bloque form-item">
          <ion-label position="stacked">COMPROMISOS ADQUIRIDOS
            <span class="required" *ngIf="getTipoReporteRegistro() === 'digital'">*</span>
          </ion-label>
          <ion-textarea formControlName="compromisos" placeholder="Compromisos adquiridos." rows="2"
            class="registro-textarea" maxlength="500"></ion-textarea>
          <div class="contador-caracteres">
            {{ formularioRegistro.get('compromisos')?.value?.length || 0 }} de 500
          </div>
        </div>
      </section>

      <section class="registro-seccion" *ngIf="getTipoReporteRegistro()">
        <h3 class="registro-seccion-titulo">
          ADJUNTOS
          <span class="required" *ngIf="getTipoReporteRegistro() === 'papel'">*</span>
        </h3>
        <p class="registro-hint">Cada archivo debe tener una categoría. Use el botón + para agregar más.</p>
        <div class="registro-adjuntos">
          <div class="registro-fila-adjunto" *ngFor="let item of itemsRegistroArchivos; let i = index"
            [class.registro-fila-adjunto-guardado]="esAdjuntoRegistroGuardado(item)">
            <ng-container *ngIf="esAdjuntoRegistroGuardado(item); else filaArchivoNuevoRegistro">
              <div class="registro-fila-archivo registro-fila-archivo-guardado">
                <ion-icon name="document-attach-outline" class="registro-adjunto-icono-doc" aria-hidden="true"></ion-icon>
                <span class="registro-nombre-archivo-guardado" [title]="nombreArchivoRegistroFila(i)">
                  {{ nombreArchivoRegistroFila(i) }}
                </span>
                <ion-button fill="clear" size="small" class="btn-ver-adjunto-registro"
                  *ngIf="(item.adjuntoGuardado?.ruta_almacenamiento || '').trim()"
                  (click)="abrirODescargarAdjunto(item.adjuntoGuardado!)"
                  title="Visualizar archivo"
                  aria-label="Visualizar archivo">
                  <ion-icon slot="icon-only" name="eye-outline"></ion-icon>
                </ion-button>
              </div>
              <span class="registro-categoria-guardada">{{ textoCategoriaAdjuntoHistorial(item.adjuntoGuardado!) }}</span>
            </ng-container>
            <ng-template #filaArchivoNuevoRegistro>
              <div class="registro-fila-archivo">
                <input type="file" [id]="'file-registro-' + i" class="file-input-registro" [attr.accept]="fileUploadAccept"
                  (change)="onArchivoRegistroFilaChange(i, $event)">
                <label [for]="'file-registro-' + i" class="file-label-registro">
                  {{ nombreArchivoRegistroFila(i) }}
                </label>
              </div>
              <ion-select [value]="item.id_categoria || ''" placeholder="Categoría" interface="popover"
                [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }"
                (ionChange)="onCategoriaRegistroFilaChange(i, $any($event).detail?.value)"
                class="registro-select-categoria"
                [class.ion-invalid]="item.file && !item.id_categoria"
                [class.ion-touched]="item.file && !item.id_categoria">
                <ion-select-option value="">Seleccione Categoría</ion-select-option>
                <ion-select-option *ngFor="let cat of categoriasAnexo" [value]="cat.id">{{ cat.descripcion
                  }}</ion-select-option>
              </ion-select>
              <div class="registro-error-adjunto" *ngIf="item.file && !item.id_categoria" role="alert" aria-live="polite">
                Seleccione Categoría <span class="required">*</span>
              </div>
            </ng-template>
            <ion-button fill="clear" size="small" color="danger" class="btn-quitar-adjunto"
              (click)="eliminarFilaArchivoRegistro(i)"
              [title]="esAdjuntoRegistroGuardado(item) ? 'Quitar de la lista' : 'Quitar archivo'"
              [attr.aria-label]="esAdjuntoRegistroGuardado(item) ? 'Quitar de la lista' : 'Quitar archivo'">
              <ion-icon slot="icon-only" name="trash-outline" aria-hidden="true"></ion-icon>
            </ion-button>
          </div>
          <ion-button fill="outline" size="small" class="btn-agregar-adjunto" (click)="agregarFilaArchivoRegistro()">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            AGREGAR ARCHIVO
          </ion-button>
        </div>
      </section>
    </form>

    <!-- Formulario estándar (nueva, reagendar, cancelar) -->
    <form [formGroup]="formulario" *ngIf="!cargando && accion !== 'ver-detalles' && !esAccionRegistrar()">
      <!-- 1. Usuario INDAP: en reagendar solo texto estático; en nueva/cancelar, select con búsqueda -->
      <div class="form-item-usuario-indap">
        <ion-label position="stacked">Usuario INDAP <span class="required">*</span></ion-label>
        <!-- Reagendar: nombre como texto estático (no editable) -->
        <div *ngIf="accion === 'reagendar'" class="usuario-indap-texto-estatico">
          {{ getNombreProductorReagendar() }}
        </div>
        <!-- Nueva visita / cancelar: búsqueda + select -->
        <div *ngIf="accion !== 'reagendar'" class="usuario-indap-container">
          <ion-searchbar [(ngModel)]="terminoBusquedaProductor" (ionInput)="onBuscarProductor($event)"
            placeholder="Buscar ..." debounce="500" [ngModelOptions]="{standalone: true}" class="searchbar-productor">
          </ion-searchbar>
          <div class="select-container">
            <ion-select formControlName="id_productor" [placeholder]="placeholderSelectUsuarioIndap" interface="popover"
              [interfaceOptions]="{ cssClass: 'select-popover select-popover-large' }"
              (ionChange)="onProductorChange($event)">
              <ion-select-option *ngFor="let productor of (productoresFiltrados || [])"
                [value]="productor.id_productor">
                {{ getNombreCompletoProductor(productor) }}
              </ion-select-option>
            </ion-select>
            <ion-spinner *ngIf="cargandoProductores" name="crescent" class="spinner-productores"></ion-spinner>
          </div>
          <p *ngIf="mostrarAvisoBusquedaProductorSinResultados" class="productor-busqueda-sin-resultados" role="status"
            aria-live="polite">
            No se encontraron usuarios con ese criterio. Pruebe con otro término o borre la búsqueda para ver el listado
            completo.
          </p>
        </div>
      </div>

      <!-- 2. Lugar de la Visita -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Lugar de la Visita <span class="required">*</span></ion-label>
        <ion-input formControlName="lugar" placeholder="Ej: Fundo El Encanto, Parcela 2"
          [readonly]="esCampoDeshabilitado()" (ionInput)="onCampoTextoChange()">
        </ion-input>
      </ion-item>

      <!-- 5. Tipo de Visita y Objetivo(s) -->
      <div class="tipo-objetivo-container">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Tipo de Visita <span class="required">*</span></ion-label>
          <ion-select formControlName="id_tipo_visita" placeholder="Seleccione un tipo"
            [disabled]="esTipoVisitaDeshabilitado()" interface="popover"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }"
            (ionChange)="onTipoVisitaChange($event)">
            <ion-select-option *ngFor="let tipo of (obtenerTiposVisita() || [])" [value]="tipo.id_tipo_visita">
              {{ tipo.descripcion }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <div class="form-item form-item-objetivos">
          <ion-label position="stacked">Temas</ion-label>
          <app-selector-objetivos-visita-registro
            formControlName="id_objetivo_visita"
            [objetivosVisita]="objetivosVisita">
          </app-selector-objetivos-visita-registro>
        </div>
      </div>

      <!-- 3. Fecha y Hora Programada (en la misma fila) -->
      <div class="fecha-hora-container">
        <!-- Fecha Programada -->
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Fecha Programada <span class="required">*</span></ion-label>
          <ion-datetime-button datetime="datetime-fecha" [disabled]="esModoSoloLectura()" ></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true" (didPresent)="forzarRecreacionDatetime()">
            <ng-template>
              <ion-datetime 
                id="datetime-fecha" [value]="fechaProgramadaISO || undefined" [min]="getFechaMinimaISO()"
                [max]="getFechaMaximaISO()" (ionChange)="onFechaChange($event)" locale="es-CL" presentation="date"
                [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }"
                [disabled]="esModoSoloLectura()">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>

        <!-- Hora Programada -->
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Hora Programada</ion-label>
          <ion-datetime-button datetime="datetime-hora" [disabled]="esModoSoloLectura()"></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime id="datetime-hora" [value]="horaProgramada || undefined" (ionChange)="onHoraChange($event)"
                locale="en-US" presentation="time"
                [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }"
                [disabled]="esModoSoloLectura()">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>
      </div>

      <!-- Describa otro (ancho completo, debajo de Tipo de Visita y Temas) -->
      <ion-item class="form-item form-item-fila-completa" lines="none" *ngIf="formulario.get('id_objetivo_visita')?.value?.includes(13)">
        <ion-label position="stacked">Describa otro <span class="required">*</span></ion-label>
        <ion-input formControlName="objetivo_otro" placeholder="Describa el tema" (ionInput)="onCampoTextoChange()"></ion-input>
      </ion-item>

      <ion-item class="form-item form-item-checkbox" lines="none" *ngIf="accion === 'nueva' || accion === 'reagendar'">
        <ion-checkbox formControlName="bolsa_visita" labelPlacement="end" [disabled]="esBolsaVisitaDeshabilitada()">
          Bolsa de Visita
        </ion-checkbox>
      </ion-item>

      <!-- Descripción de la visita (agendar / reagendar / agendar desde planificada) -->
      <ion-item class="form-item" lines="none" *ngIf="accion === 'nueva' || accion === 'reagendar'">
        <ion-label position="stacked">Descripción <span class="required">*</span></ion-label>
        <ion-textarea formControlName="descripcion" placeholder="Describa el objetivo o alcance de la visita" rows="3"
          [readonly]="esCampoDeshabilitado() || esDescripcionDeshabilitada()" (ionInput)="onCampoTextoChange()">
        </ion-textarea>
      </ion-item>

      <!-- 6. Comentarios (oculto en agendar y reagendar) -->
      <ion-item class="form-item" lines="none" *ngIf="accion !== 'nueva' && accion !== 'reagendar'">
        <ion-label position="stacked">Comentarios</ion-label>
        <ion-textarea formControlName="comentarios" placeholder="Añada comentarios u observaciones adicionales."
          rows="2" [readonly]="esCampoDeshabilitado()">
        </ion-textarea>
      </ion-item>

      <!-- 7. Archivo Anexo (oculto en agendar y reagendar) -->
      <ion-item class="form-item" lines="none" *ngIf="accion !== 'nueva' && accion !== 'reagendar'">
        <ion-label position="stacked">Archivo Anexo</ion-label>
        <input type="file" formControlName="archivo_anexo" [attr.accept]="fileUploadAccept"
          (change)="onArchivoSeleccionado($event)" [disabled]="esCampoDeshabilitado()" class="file-input">
      </ion-item>

      <!-- 8. Categoría del Anexo (oculto en agendar y reagendar) -->
      <ion-item class="form-item" lines="none" *ngIf="accion !== 'nueva' && accion !== 'reagendar'">
        <ion-label position="stacked">Categoría del Anexo</ion-label>
        <ion-select formControlName="categoria_anexo" placeholder="Seleccione una categoría"
          [disabled]="esCategoriaAnexoDeshabilitado()" interface="popover"
          [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
          <ion-select-option *ngFor="let categoria of categoriasAnexo" [value]="categoria.id">
            {{ categoria.descripcion }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <!-- 9. Es Emergencia (selector obligatorio: Seleccione / Sí / No) -->
      <div class="toggle-emergencia-wrapper">
        <ion-item class="form-item form-item-emergencia" lines="none">
          <ion-label position="stacked">Es Emergencia <span class="required">*</span></ion-label>
          <ion-select formControlName="es_contingencia" placeholder="Seleccione" [disabled]="esCampoDeshabilitado()"
            interface="popover" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }"
            helperText="Marque si la visita se debe a una emergencia o imprevisto.">
            <ion-select-option [value]="null">Seleccione</ion-select-option>
            <ion-select-option [value]="true">Sí</ion-select-option>
            <ion-select-option [value]="false">No</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-button [id]="idEmergenciaInfo" fill="clear" size="small" class="boton-informacion"
          aria-label="Información">
          <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-popover [trigger]="idEmergenciaInfo" [triggerAction]="'click'" reference="trigger" [side]="'top'"
          [alignment]="'center'">
          <ng-template>
            <div class="popover-informacion">
              <p>Visita asociada a emergencia agrícola o catástrofe declarada por la autoridad competente, o definida por la Dirección Nacional de INDAP conforme a la Ley N°18.910. No contempla urgencias propias del manejo habitual del predio.</p>
            </div>
          </ng-template>
        </ion-popover>
      </div>

      <ion-item class="form-item" lines="none" *ngIf="mostrarCampoDescripcionEmergencia()">
        <ion-label position="stacked">Descripción de la emergencia</ion-label>
        <ion-textarea formControlName="descripcion_emergencia"
          placeholder="Indique brevemente el motivo de la emergencia" rows="3" [readonly]="esCampoDeshabilitado()">
        </ion-textarea>
      </ion-item>
    </form>
  </div>

  <!-- Footer con botones -->
  <div class="formulario-footer" *ngIf="!cargando && accion !== 'ver-detalles'">
    <ion-button *ngIf="accion !== 'registrar'" fill="outline" (click)="cerrar()" [disabled]="guardando">
      Cancelar
    </ion-button>
    <ion-button *ngIf="accion === 'registrar'" fill="outline" (click)="guardarProgreso()" [disabled]="guardando">
      <ion-icon slot="start" name="save-outline"></ion-icon>
      Guardar Progreso
    </ion-button>
    <ion-button *ngIf="!esModoSoloLectura()" (click)="guardar()" [disabled]="guardando || !esFormularioValido()">
      <ion-icon slot="start" name="paper-plane-outline"></ion-icon>
      {{ getTextoBotonGuardar() }}
    </ion-button>
  </div>

  <!-- Footer solo con botón Cerrar para Ver Detalles -->
  <div class="formulario-footer" *ngIf="!cargando && accion === 'ver-detalles'">
    <ion-button fill="outline" (click)="cerrar()">
      Cerrar
    </ion-button>
  </div>
</ng-template>